import React from 'react';
import { EllipsisVerticalIcon } from '@heroicons/react/24/outline';

type InvoiceAction = {
  label: string;
  dangerous?: boolean;
  onClick: () => void;
};

type Props = {
  menuId: string;
  openMenuId: string | null;
  setOpenMenuId: (id: string | null) => void;
  invoiceNumber: string;
  actions: InvoiceAction[];
};

export default function InvoiceActionMenu({
  menuId,
  openMenuId,
  setOpenMenuId,
  invoiceNumber,
  actions,
}: Props) {
  return (
    <div className="relative">
      <button
        type="button"
        onClick={(event) => {
          event.stopPropagation();
          setOpenMenuId(openMenuId === menuId ? null : menuId);
        }}
        className="admin-action-pill rounded-md bg-surface-container-low px-2 py-1 text-xs font-medium text-on-surface hover:bg-surface-container-highest"
        aria-label={`Open actions for ${invoiceNumber}`}
      >
        <EllipsisVerticalIcon className="h-4 w-4" />
      </button>
      {openMenuId === menuId && (
        <div
          className="absolute right-0 z-20 mt-1 min-w-[11rem] rounded-md border border-outline/70 bg-surface-container-lowest py-1 shadow-lg"
          onClick={(event) => event.stopPropagation()}
        >
          {actions.length === 0 ? (
            <span className="block px-3 py-2 text-xs text-on-surface-variant">No actions</span>
          ) : (
            actions.map((action) => (
              <button
                key={action.label}
                type="button"
                onClick={() => {
                  setOpenMenuId(null);
                  action.onClick();
                }}
                className={`block w-full px-3 py-2 text-left text-xs font-medium hover:bg-surface-container ${action.dangerous ? 'text-error' : 'text-on-surface'}`}
              >
                {action.label}
              </button>
            ))
          )}
        </div>
      )}
    </div>
  );
}
